export function useClearShipperContact(modelValue) {

    modelValue.shipper.shipperContactId = 0;
    modelValue.shipper.shipperContactFullName = '';
    modelValue.shipper.shipperContactTitle = '';
    modelValue.shipper.shipperContactFirstName = '';
    modelValue.shipper.shipperContactLastName = '';
    modelValue.shipper.shipperContactPhone = '';
    modelValue.shipper.shipperContactEmail = '';
    modelValue.shipper.shipperContactDepartment = '';
}
